<style>
	.statistics div {
		width: 100%;
	}

	.statistics_name {
		width: 100%;
	}

	.statistics_number {
		margin-top: 5px;
		width: 20px;
	}
</style>
<template>
	<div ref="content" class="content background2 searchBox3">
		<div class="userNavBox">
			<div class="navSearch">
				<div class="searchBox-black">
					<label class="searchBox-label">人员</label>
					<div class="searchBox-condition" style="width: 150px">
						<!-- <el-select class="select-class" v-model="searchList.fullName" placeholder="请选择">
						  <el-option :label="'全部'" :value="''"></el-option>
						  <el-option v-for="item in customerList" :key="item.id" :label="item.name" :value="item.id">
						  </el-option>
						</el-select> -->
						<el-input class="input-class el-input" v-model="searchList.fullName"></el-input>
					</div>
				</div>
				<div class="searchBox-black">
					<label class="searchBox-label">时间</label>
					<div class="searchBox-condition">
						<el-date-picker v-model="searchDate" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
						</el-date-picker>
					</div>
				</div>
				<div class="searchButton" @click="search({ pageNo: 1, pageSize: pageSize })">
					查询
				</div>
			</div>
			<div class="navTable">
				<div class="tableTitle">
					<p class="title">详细内容</p>
					<excel-export :filename="utils.getNowFormatDate() + '处理时间统计表'" :sheet="sheet">
						<!-- <div class="exportButton" v-if="this.menuList.indexOf('CD_521') != -1"> -->
						<div class="exportButton" @click="getExcelList()" v-if="menuList.indexOf('CD_521') != -1">导出
						</div>
					</excel-export>
				</div>
				<div class="tableBox list" ref="tableList" :style="{ 'padding-top': paddingTop }">
					<List ref="list" :tableData="tableData" :tableList="tableList" :pageSize="pageSize" :pageNo="pageNo"
						:checkBox="true" @parentMethod="getInfo" @checkMethod="getCheckInfo"></List>
				</div>
				<div ref="page" class="page">
					<div class="statistics">
						<div>
							<p style="statistics_name">平均接单时间</p>
							<p class="statistics_number">{{stateList.averageOrderTime}}</p>
						</div>
						<div>
							<p style="statistics_name">平均到场时间</p>
							<p class="statistics_number">{{stateList.averagePresentTime}}</p>
						</div>
						<div>
							<p style="statistics_name">平均完成工单用时</p>
							<p class="statistics_number">{{stateList.completionTime}}</p>
						</div>
					</div>
					<Page ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
						@parentMethod="search"></Page>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/common/list.css";
	import SearchList from "@/components/list/searchList";
	import BtnList from "@/components/list/btnList";
	import List from "@/components/list/list";
	import Page from "@/components/common/page";
	import CommonJs from "@/assets/js/common/common.js";
	import staListJs from "@/assets/js/sticList/stic.js";
	export default {
		name: "list",
		components: {
			List,
			SearchList,
			BtnList,
			Page,
		},
		data() {
			const $this = this;
			return {
				paddingTop: 0,
				value1: "",
				searchDate: "",
				options: [],
				workloadList: [],
				ExcelList: [],
				customerList: [],
				tableList: [{
						column: "fullName",
						title: "人员名称",
						headerAlign: "center",
						align: "center",
						width: "20%",
					},
					{
						column: "averageOrderTime",
						title: "平均接单时间",
						headerAlign: "center",
						align: "center",
						width: "20%",
					},
					{
						column: "averagePresentTime",
						title: "平均到场时间",
						headerAlign: "center",
						align: "center",
						width: "20%",
					},
					{
						column: "averageCompletionTime",
						title: "平均完成工单用时",
						headerAlign: "center",
						align: "center",
						width: "20%",
					},
				],
				multipleSelection: [],
				tableData: [],
				checkboxList: [],
				menuList: [],
				stateList: {},
				tableInfo: {},
				searchList: {
					user: "",
					fullName: "",
					time1: "",
					time2: "",
					city: "",
					district: "",
				},
				sheet: [{
					title: "处理时间统计表",
					tHeader: [
						"人员名称",
						"平均接单时间",
						"平均到场时间",
						"平均完成工单用时",
					],
					keys: [
						"fullName",
						"averageOrderTime",
						"averagePresentTime",
						"averageCompletionTime",
					],
					table: [],
					sheetName: "处理时间统计",
					cellStyle: [{
						cell: "A1",
						font: {
							name: "黑体",
							sz: "18px",
						},
					}, ],
				}, ],
				pageCount: 0,
				pageSize: 0,
				pageNo: 1,
			};
		},
		methods: {
			test(item) {
				if (item.district != null) {
					this.searchList.district = item.district;
				} else if (item === "all") {
					this.searchList.city = "";
				} else {
					this.searchList.city = item;
				}
				this.search({
					pageNo: 1,
					pageSize: this.pageSize,
				});
			},
			search(param) {
				this.searchList.time1 = this.searchDate ? this.searchDate[0] || "" : "";
				this.searchList.time2 = this.searchDate ? this.searchDate[1] || "" : "";
				var newParam = Object.assign(param, this.searchList);
				this.getHandlingTimeStatistics(newParam);
				this.getHandlingTimeStatisticsAggregate(newParam);
				this.searchList.district = "";
			},
			getExcelList() { //导出
				// this.searchList.time1 = this.searchDate ? this.searchDate[0] || '' : '';
				// this.searchList.time2 = this.searchDate ? this.searchDate[1] || '' : '';
				// this.searchList.user = this.checkboxList.join();
				// var newParam = Object.assign(this.searchList);
				// staListJs.getHandlingTimeStatisticsList(newParam)
				// 	.then((response) => {
				// 		const data = response.data;
				// 		if (data.code == 1) {
				var list = [];
				var $this = this;
				this.ExcelList.forEach(function(item, index) {
					var newItem = {};
					newItem.fullName = item.fullName == null ? " " : item.fullName;
					newItem.averageOrderTime =
						item.averageOrderTime == null ? " " : item.averageOrderTime;
					newItem.averagePresentTime =
						item.averagePresentTime == null ? " " : item.averagePresentTime;
					newItem.averageCompletionTime =
						item.averageCompletionTime == null ? " " : item.averageCompletionTime;
					list.push(newItem);
				});
				this.sheet[0].table = list;
				// }
				// })
				// .catch((response) => {});
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			getInfo(info) {
				this.tableInfo = info;
			},
			getCheckInfo(info) {
				this.checkboxInfo = info;
				this.checkboxList = [];
				for (var i = 0; i < this.checkboxInfo.length; i++) {
					this.checkboxList.push(this.checkboxInfo[i].supportPerson);
				}
				this.searchList.time1 = this.searchDate ? this.searchDate[0] || "" : "";
				this.searchList.time2 = this.searchDate ? this.searchDate[1] || "" : "";
				this.searchList.user = this.checkboxList.join();
				var newParam = Object.assign(this.searchList);
				staListJs
					.getHandlingTimeStatisticsList(newParam)
					.then((response) => {
						const data = response.data;
						this.ExcelList = data.data;
					})
					.catch((response) => {});
			},
			// getUserBy() {
			// 	CommonJs.getUserByName().then((response) => {
			// 		const data = response.data;
			// 		this.supportPersonList = data.data;

			// 		let list = [];
			// 		for (var i = 0; i < this.supportPersonList.length; i++) {
			// 			if(this.supportPersonList[i].fullName !="" && this.supportPersonList[i].fullName !=null){
			// 				list.push({
			// 					id: this.supportPersonList[i].userId.toString(),
			// 					name: this.supportPersonList[i].fullName,
			// 				});
			// 			}
			// 		}
			// 		this.customerList = list;
			// 	});
			// },
			getHandlingTimeStatistics(param) {
				staListJs.getHandlingTimeStatistics(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableData = data.data.records;
						this.pageCount = data.data.total;
						this.pageNo = data.data.current;
					}
				});
			},
			getHandlingTimeStatisticsAggregate(param) {
				staListJs.getHandlingTimeStatisticsAggregate(param).then((response) => {
					const data = response.data;
					console.log(JSON.stringify(data));
					if (data.code == "1") {
						this.stateList = data.data;
						//   this.tableData = data.data.records;
						//   this.pageCount = data.data.total;
						//   this.pageNo = data.data.current;
					}
				});
			},
			getWindowHeight() {
				let height = "";
				height = this.$refs.tableList.clientHeight - 220;
				this.height = height;
				if (height > 550) {
					let line = parseInt((height - 10) / 50);
					if (this.pageSize != line) {
						this.pageSize = line;
					}
				} else {
					if (this.pageSize != 10) {
						this.pageSize = 10;
					}
				}
				this.search({
					pageNo: 1,
					pageSize: this.pageSize,
				});
			},
		},
		created() {
			this.menuList = this.$store.getters.getMenuPermission;
			var a = [];
			a.push(
				new Date(
					Date.UTC(
						new Date().getFullYear(),
						new Date().getMonth(),
						new Date().getDate() - 6
					)
				)
				.toISOString()
				.slice(0, 10)
			);
			a.push(
				new Date(
					Date.UTC(
						new Date().getFullYear(),
						new Date().getMonth(),
						new Date().getDate()
					)
				)
				.toISOString()
				.slice(0, 10)
			);
			this.searchDate = a;
		},
		mounted() {
			this.paddingTop = "140px";
			this.getWindowHeight();
			window.onresize = () => {
				this.$refs.list.getHeight();
				this.getWindowHeight();
			};
			this.menuList = this.$store.getters.getMenuPermission;
			// this.getUserBy();
			window.test = this.test;
		},
	};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/statisticsList/processTime.vue